import { fromJS } from 'immutable';
import { basicSort } from '../../../../util/sortUtils';
import { sort, visibleColumns } from './depositReduxConstants';
import { augmentData } from '../depositReduxUtils';
import { resolveErrors } from '../../../../components/grid/resultGridUtils';

export const DEPOSIT_SEARCH_REQUEST = 'DEPOSIT_SEARCH_REQUEST';
export const DEPOSIT_SEARCH_SUCCESS = 'DEPOSIT_SEARCH_SUCCESS';
export const DEPOSIT_SEARCH_FAILURE = 'DEPOSIT_SEARCH_FAILURE';

export const DEPOSIT_SEARCH_CLEAR = 'DEPOSIT_SEARCH_CLEAR';
export const DEPOSIT_DATA_CLEAR = 'DEPOSIT_DATA_CLEAR';
export const DEPOSIT_SEARCH_CLEAR_REDIRECT = 'DEPOSIT_SEARCH_CLEAR_REDIRECT';

export const DEPOSIT_SEARCH_PUBLICATION_REQUEST = 'DEPOSIT_SEARCH_PUBLICATION_REQUEST';
export const DEPOSIT_SEARCH_PUBLICATION_SUCCESS = 'DEPOSIT_SEARCH_PUBLICATION_SUCCESS';
export const DEPOSIT_SEARCH_PUBLICATION_FAILURE = 'DEPOSIT_SEARCH_PUBLICATION_FAILURE';

export const DEPOSIT_SEARCH_WATER_REQUEST = 'DEPOSIT_SEARCH_WATER_REQUEST';
export const DEPOSIT_SEARCH_WATER_SUCCESS = 'DEPOSIT_SEARCH_WATER_SUCCESS';
export const DEPOSIT_SEARCH_WATER_FAILURE = 'DEPOSIT_SEARCH_WATER_FAILURE';

export const DEPOSIT_SEARCH_COUNTRY_REQUEST = 'DEPOSIT_SEARCH_COUNTRY_REQUEST';
export const DEPOSIT_SEARCH_COUNTRY_SUCCESS = 'DEPOSIT_SEARCH_COUNTRY_SUCCESS';
export const DEPOSIT_SEARCH_COUNTRY_FAILURE = 'DEPOSIT_SEARCH_COUNTRY_FAILURE';

export const DEPOSIT_SEARCH_GEOAGE_REQUEST = 'DEPOSIT_SEARCH_GEOAGE_REQUEST';
export const DEPOSIT_SEARCH_GEOAGE_SUCCESS = 'DEPOSIT_SEARCH_GEOAGE_SUCCESS';
export const DEPOSIT_SEARCH_GEOAGE_FAILURE = 'DEPOSIT_SEARCH_GEOAGE_FAILURE';

export const DEPOSIT_DATA_DELETE_DEPOSIT_REQUEST = 'DEPOSIT_DATA_DELETE_DEPOSIT_REQUEST';
export const DEPOSIT_DATA_DELETE_DEPOSIT_SUCCESS = 'DEPOSIT_DATA_DELETE_DEPOSIT_SUCCESS';
export const DEPOSIT_DATA_DELETE_DEPOSIT_FAILURE = 'DEPOSIT_DATA_DELETE_DEPOSIT_FAILURE';

export const DEPOSIT_DATA_TOGGLE_COLUMN = 'DEPOSIT_DATA_TOGGLE_COLUMN';

export const DEPOSIT_DATA_SORT = 'DEPOSIT_DATA_SORT';

export const DEPOSIT_DATA_SAVE_OPEN_CONFIRMATION = 'DEPOSIT_DATA_SAVE_OPEN_CONFIRMATION';
export const DEPOSIT_DATA_SAVE_CANCEL_CONFIRMATION = 'DEPOSIT_DATA_SAVE_CANCEL_CONFIRMATION';
export const DEPOSIT_DATA_CANCEL_EDIT = 'DEPOSIT_DATA_CANCEL_EDIT';
export const DEPOSIT_DATA_EDIT = 'DEPOSIT_DATA_EDIT';
export const DEPOSIT_DATA_BULK_EDIT_REQUEST = 'DEPOSIT_DATA_BULK_EDIT_REQUEST';
export const DEPOSIT_DATA_BULK_EDIT_SUCCESS = 'DEPOSIT_DATA_BULK_EDIT_SUCCESS';
export const DEPOSIT_DATA_BULK_EDIT_FAILURE = 'DEPOSIT_DATA_BULK_EDIT_FAILURE';


const initialState = fromJS({
  deleting: false,
  visibleColumns,

  searching: false,
  fetched: false,
  deposits: [],
  queryParameters: {},
  searchRedirect: false,

  fetchedPublications: false,
  publications: [],
  fetchedBodiesOfWater: false,
  bodiesOfWater: [],
  fetchedCountries: false,
  countries: [],
  fetchedGeologicAges: false,
  geologicAges: [],

  sort,

  saving: false,
  formData: {},
  initialFormData: {},
  editConfirmationOpen: false,
  errors: {},
  editing: false,
  initialValues: {},

});

// default param first is the redux convention https://redux.js.org/tutorials/fundamentals/part-3-state-actions-reducers
// eslint-disable-next-line default-param-last
export const depositSearchReducer = (state = initialState, action) => {
  switch (action.type) {
    case DEPOSIT_DATA_EDIT:
      return state.merge(fromJS({
        errors: {},
        editing: true,
        initialValues: action.initialValues,
      }));
    case DEPOSIT_DATA_CANCEL_EDIT:
      return state.merge(fromJS({
        errors: {},
        editing: false,
        initialValues: {},
      }));

    case DEPOSIT_DATA_SAVE_OPEN_CONFIRMATION:
      return state.merge(fromJS({
        formData: action.formData,
        initialFormData: action.initialFormData,
        editConfirmationOpen: true,
      }));
    case DEPOSIT_DATA_SAVE_CANCEL_CONFIRMATION:
      return state.merge(fromJS({
        formData: {},
        initialFormData: {},
        editConfirmationOpen: false,
      }));

    case DEPOSIT_DATA_BULK_EDIT_REQUEST:
      return state.merge(fromJS({
        saving: true,
        errors: {},
      }));
    case DEPOSIT_DATA_BULK_EDIT_SUCCESS:
      return state.merge(fromJS({
        saving: false,
        errors: {},
      }));
    case DEPOSIT_DATA_BULK_EDIT_FAILURE:
      return state.merge(fromJS({
        saving: false,
        errors: resolveErrors(action.response),
      }));

    case DEPOSIT_SEARCH_CLEAR_REDIRECT:
      return state.set('searchRedirect', false);
    case DEPOSIT_DATA_CLEAR:
      return initialState.merge(fromJS({
        sort: state.get('sort'),
        visibleColumns: state.get('visibleColumns'),
        deposits: state.get('deposits'),
        fetched: state.get('fetched'),
      }));
    case DEPOSIT_SEARCH_CLEAR:
      return initialState.merge(fromJS({
        sort: state.get('sort'),
        visibleColumns: state.get('visibleColumns'),
      }));
    case DEPOSIT_DATA_SORT:
      return state.merge(fromJS({
        deposits: basicSort(action.sort, state.get('deposits')),
        sort: action.sort,
      }));

    case DEPOSIT_DATA_DELETE_DEPOSIT_REQUEST:
      return state.set('deleting', true);
    case DEPOSIT_DATA_DELETE_DEPOSIT_SUCCESS:
    case DEPOSIT_DATA_DELETE_DEPOSIT_FAILURE:
      return state.set('deleting', false);

    case DEPOSIT_DATA_TOGGLE_COLUMN:
      return state.merge(fromJS({
        visibleColumns: action.visibleColumns,
      }));

    case DEPOSIT_SEARCH_REQUEST:
      return state.merge(fromJS({
        searching: true,
        fetched: false,
        queryParameters: action.queryParameters,
        searchRedirect: Boolean(action.searchRedirect),
      }));
    case DEPOSIT_SEARCH_SUCCESS:
      return state.merge(fromJS({
        searching: false,
        fetched: true,
        deposits: basicSort(state.get('sort'), augmentData({
          deposits: fromJS(action.response.items),
          geologicAges: state.get('geologicAges'),
          publications: state.get('publications'),
        })),
      }));
    case DEPOSIT_SEARCH_FAILURE:
      return state.merge(fromJS({
        searching: false,
        fetched: true,
      }));

    case DEPOSIT_SEARCH_PUBLICATION_REQUEST:
      return state.merge(fromJS({
        fetchedPublications: false,
      }));
    case DEPOSIT_SEARCH_PUBLICATION_SUCCESS: {
      const publications = fromJS(action.response.items);
      return state.merge(fromJS({
        fetchedPublications: true,
        publications,
        deposits: basicSort(state.get('sort'), augmentData({
          deposits: state.get('deposits'),
          publications,
        })),
      }));
    }
    case DEPOSIT_SEARCH_PUBLICATION_FAILURE:
      return state.merge(fromJS({
        fetchedPublications: true,
      }));

    case DEPOSIT_SEARCH_WATER_REQUEST:
      return state.merge(fromJS({
        fetchedBodiesOfWater: false,
      }));
    case DEPOSIT_SEARCH_WATER_SUCCESS:
      return state.merge(fromJS({
        fetchedBodiesOfWater: true,
        bodiesOfWater: action.response.items,
      }));
    case DEPOSIT_SEARCH_WATER_FAILURE:
      return state.merge(fromJS({
        fetchedBodiesOfWater: true,
      }));


    case DEPOSIT_SEARCH_COUNTRY_REQUEST:
      return state.merge(fromJS({
        fetchedCountries: false,
      }));
    case DEPOSIT_SEARCH_COUNTRY_SUCCESS:
      return state.merge(fromJS({
        fetchedCountries: true,
        countries: action.response.items,
      }));
    case DEPOSIT_SEARCH_COUNTRY_FAILURE:
      return state.merge(fromJS({
        fetchedCountries: true,
      }));

    case DEPOSIT_SEARCH_GEOAGE_REQUEST:
      return state.merge(fromJS({
        fetchedGeologicAges: false,
      }));
    case DEPOSIT_SEARCH_GEOAGE_SUCCESS: {
      const geologicAges = fromJS(action.response.items);
      return state.merge(fromJS({
        fetchedGeologicAges: true,
        geologicAges,
        deposits: basicSort(state.get('sort'), augmentData({
          deposits: state.get('deposits'),
          geologicAges,
        })),
      }));
    }
    case DEPOSIT_SEARCH_GEOAGE_FAILURE:
      return state.merge(fromJS({
        fetchedGeologicAges: true,
      }));


    default:
      return state;
  }
};
